module.exports = __webpack_public_path__ + "img/a0309_8.67939447.png";